import type { ReactNode } from 'react';
import { cn } from './cn';

const TONE = {
  // "Leader" next to the member count.
  leader: 'rounded-xs bg-tag-leader px-internal-md py-0.5 text-caption-sm text-on-tag',
  // Figma badge/role: a person's role in a group, 14px bold with 4px all round.
  'role-facilitator':
    'rounded-xs bg-role-facilitator p-internal-sm text-body-xs font-bold text-on-role-facilitator',
  'role-leader':
    'rounded-xs bg-role-leader p-internal-sm text-body-xs font-bold text-on-role-leader',
  'role-member':
    'rounded-xs bg-role-member p-internal-sm text-body-xs font-bold text-on-role-member',
  // The kind of text on a Library row ("Short story").
  info: 'rounded-full bg-tag-info px-internal-md py-internal-sm text-caption-sm text-on-tag-info',
} as const;

/** DESIGN.md › tag / tag-info: a tiny caption label on a fill. */
export function Tag({
  tone = 'leader',
  className,
  children,
}: {
  tone?: keyof typeof TONE;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex self-start font-brand',
        TONE[tone],
        tone.startsWith('role-') && 'leading-[var(--text-caption-sm--line-height)]',
        className,
      )}
    >
      {children}
    </span>
  );
}
